import { Component, OnInit, Input, AfterViewInit, ChangeDetectorRef, input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonFunctions } from 'src/app/shared/common/common-functions';
import { PayrollInfoPeriod } from 'src/app/store/feature-stores/payroll-store/models';
import { UntypedFormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
    selector: 'app-payroll-field',
    templateUrl: './payroll-field.component.html',
    styleUrls: ['./payroll-field.component.scss'],
    standalone: false,
})
export class PayrollFieldComponent implements AfterViewInit, OnChanges {
  @Input() formGroup?: UntypedFormGroup;
  @Input() propertyId?: string;
  @Input() isRegularPayrollField?: boolean = true;
  @Input() isYearPayrollField?: boolean = true;
  @Input() payrollInfoPeriods?: PayrollInfoPeriod[];
  @Input() applyMinValidator?: boolean = false;

  parentElement: string[] = [];
  childElement: string[] = [];

  constructor(private router: Router, private cdr: ChangeDetectorRef) { }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (this.applyMinValidator && this.payrollInfoPeriods) {
      this.addMinValueValidators();
      console.log('applyMinValidator:', this.applyMinValidator);
      console.log('payrollInfoPeriods:', this.payrollInfoPeriods);
    }
  }

  ngAfterViewInit(): void {
    if(this.router.url.includes('corporation') && this.router.url.includes('payroll')){
      this.parentElement = ["col-lg-8", "col-md-8"];
      this.childElement = ["col-lg-4", "col-md-4"];
    } else {
      this.parentElement = ["col-lg-9", "col-md-9"];
      this.childElement = ["col-lg-3", "col-md-3"];
    }

    if (this.applyMinValidator && this.payrollInfoPeriods) {
      this.addMinValueValidators();
      console.log('applyMinValidator:', this.applyMinValidator);
      console.log('payrollInfoPeriods:', this.payrollInfoPeriods);
    }
    console.log('Final formGroup state:', this.formGroup?.value);
    this.cdr.detectChanges();
  }

  addMinValueValidators(): void {
    this.payrollInfoPeriods?.forEach((payrollInfoPeriod) => {
      const controlName = payrollInfoPeriod.id;
      if (payrollInfoPeriod.disable){
        console.log(`Skipping disabled payrollInfoPeriod: ${controlName}`);
        return;
      }
      
      if (this.formGroup?.get(controlName)) {
        console.log(`Updating validators for existing control: ${controlName}`);
        if (this.formGroup?.get(controlName)) {
          console.log(`Updating validators for existing control: ${controlName}`);
          const control = this.formGroup.get(controlName);
          const currentValue = control?.value;
          control?.setValidators([Validators.required, Validators.min(100)]);
          control?.setValue(currentValue);  // <-- re-apply value to trigger validation
          control?.updateValueAndValidity();
         }
      } else {
        console.log(`Adding new control with validators: ${controlName}`);
        this.formGroup?.addControl(
          controlName,
          new FormControl('', [Validators.required, Validators.min(100)])
        );
      }
    });
  }
}
